import './styles/Membership.css';

import React, { useEffect } from 'react';
import RegistrationContainer, {
  RegistrationContainerProps
} from './components/RegistrationContainer';
import { Route, Routes } from 'react-router';

import ApolloClientService from '../shared/services/ApolloClientService';
import { ApolloProvider } from '@apollo/client';
import AppToast from '../AppToast';
import Card from '@mui/material/Card';
import Config from '../shared/config';
import Footer from '../app/components/Footer';
import HtmlPageService from '../shared/services/HtmlPageService';
import Invitation from './components/Invitation';
import RequestPasswordResetContainer from './components/RequestPasswordResetContainer';
import RequestVerificationEmailContainer from './components/RequestVerificationEmailContainer';
import ResetMyPasswordContainer from './components/ResetMyPasswordContainer';
import SkinThemeService from '../shared/services/SkinThemeService';
import VerifyEmailContainer from './components/VerifyEmailContainer';
import { useLocation } from 'react-router-dom';
import useThemes from '../shared/hooks/useThemes';
import withTheming from './components/withTheming';

const App = () => {
  const domain = window.location.host;
  const ThemedRegistration = withTheming<RegistrationContainerProps>(
    RegistrationContainer
  );
  const ThemedRequestPasswordReset = withTheming(RequestPasswordResetContainer);
  const ThemedResetMyPassword = withTheming(ResetMyPasswordContainer);
  const ThemedVerifyEmail = withTheming(VerifyEmailContainer);
  const ThemedRequestVerificationEmail = withTheming(
    RequestVerificationEmailContainer
  );
  const ThemedInvitation = withTheming(Invitation);
  const ThemedAppToast = withTheming(AppToast);

  const graphQLQueryEndpoint = Config.MEMBERSHIP_PUBLIC_GQL;
  const apolloClient = ApolloClientService.create(graphQLQueryEndpoint);

  const { skinTheme } = useThemes();

  useEffect(() => {
    if (!skinTheme) {
      return;
    }
    HtmlPageService.setFavicon(
      SkinThemeService.getAssetUrl('container', 'favicon')
    );
    HtmlPageService.setTitle(
      SkinThemeService.getThemeOptionValue(
        skinTheme,
        'container',
        'siteName'
      ) as string
    );
  }, [skinTheme]);

  const { pathname } = useLocation();

  const ThemedComponent = () => {
    switch (pathname) {
      case '/registration':
        return <ThemedRegistration clientName={domain} />;
      case '/request-password-reset':
        return <ThemedRequestPasswordReset clientName={domain} />;
      case '/reset-my-password':
        return <ThemedResetMyPassword clientName={domain} />;
      case '/verify-email':
        return <ThemedVerifyEmail clientName={domain} />;
      case '/request-verification-email':
        return <ThemedRequestVerificationEmail clientName={domain} />;
      case '/invitation':
        return <ThemedInvitation clientName={domain} />;
      default:
        return null;
    }
  };

  return (
    <ApolloProvider client={apolloClient}>
      <div className="membership-body-content">
        <div className="membership-app-container">
          <div className="centered-panel">
            <Card>
              <Routes>
                <Route path="" element={<ThemedComponent />} />
              </Routes>
            </Card>
          </div>
          <Footer copyrightStartYear={2019} />
        </div>
      </div>
      <ThemedAppToast clientName={domain} />
    </ApolloProvider>
  );
};

export default App;
